/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LatestTransaction
 */
export interface LatestTransaction {
    /**
     * 
     * @type {number}
     * @memberof LatestTransaction
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof LatestTransaction
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof LatestTransaction
     */
    transactionType: string;
    /**
     * 
     * @type {string}
     * @memberof LatestTransaction
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof LatestTransaction
     */
    transactionAmount: string;
    /**
     * 
     * @type {string}
     * @memberof LatestTransaction
     */
    cumulativeTotal: string;
}

/**
 * Check if a given object implements the LatestTransaction interface.
 */
export function instanceOfLatestTransaction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "transactionType" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "transactionAmount" in value;
    isInstance = isInstance && "cumulativeTotal" in value;

    return isInstance;
}

export function LatestTransactionFromJSON(json: any): LatestTransaction {
    return LatestTransactionFromJSONTyped(json, false);
}

export function LatestTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'date': (new Date(json['Date'])),
        'transactionType': json['TransactionType'],
        'description': json['Description'],
        'transactionAmount': json['TransactionAmount'],
        'cumulativeTotal': json['CumulativeTotal'],
    };
}

export function LatestTransactionToJSON(value?: LatestTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Date': (value.date.toISOString()),
        'TransactionType': value.transactionType,
        'Description': value.description,
        'TransactionAmount': value.transactionAmount,
        'CumulativeTotal': value.cumulativeTotal,
    };
}

